import createVueComponent from '../createVueComponent';
export default createVueComponent('outline', 'number-17-small', 'Number17Small', [["path",{"d":"M8 8h1v8","key":"svg-0"}],["path",{"d":"M13 8h4l-2 8","key":"svg-1"}]]);